import { Component, Inject, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { db } from 'src/app/db/db';

import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Taxon } from 'src/app/domain/IBMR/IBMR-taxon';
import { SANDRETaxionModel } from 'src/app/models/SANDRE-taxon-model';
import { CoreData } from '../../core-data';
import { StringConverter } from '../string-converter';
import { EUnit } from 'src/app/domain/IBMR/enum/unit';

@Component({
    selector: 'app-taxon-ibmr-box',
    templateUrl: './taxon-ibmr-box.component.html',
    styleUrls: ['./taxon-ibmr-box.component.scss']
})
export class TaxonIBMRBoxComponent implements OnInit {
    public UnitList: string[] =
        Object.values(EUnit)
            .filter(x => !isNaN(Number(x)))
            .map((x: EUnit) => StringConverter.getUnitName(x));

    public model: Taxon = new Taxon()
    public IsCreation: boolean;

    public SearchText: string;
    public TaxonOptionList: SANDRETaxionModel[] = [];
    private subject: Subject<string> = new Subject();
    IsFocused: boolean;

    transectAlreadyPicked: Taxon[] = [];
    fullIBMRAlreadyPicked: Taxon[] = [];
    SamplingNumberAlreadyInUse: Taxon[] = [];
    IsForNewSamplingNumber: boolean = true

    get CanAdd() {
        return (this.model.NomGenre || this.model.CustomName) && (
            (this.model.Unit && (this.model.Unit === EUnit.Pourcentage && this.model.Quantite > 0 && this.model.Quantite <= 100 || (this.model.Unit !== EUnit.Pourcentage && this.model.Quantite > 0)) || this.model.Presence))
    }

    constructor(
        public CoreData: CoreData,
        public dialogRef: MatDialogRef<TaxonIBMRBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (data.taxon) {
            this.model = Object.assign({}, data.taxon);
            this.SearchText = `${this.model.Code} - ${this.model.NomGenre}`;
        }
        if (data.transectAlreadyPicked) {
            this.transectAlreadyPicked = Object.assign([], data.transectAlreadyPicked);
        }
        if (data.fullIBMRAlreadyPicked) {
            this.IsForNewSamplingNumber = false;
            this.fullIBMRAlreadyPicked = Object.assign([], data.fullIBMRAlreadyPicked);
            this.SamplingNumberAlreadyInUse = _.orderBy(_.uniqBy(this.fullIBMRAlreadyPicked.filter(x => x.Preleve), y => y.NumeroPrelevement), y => y.NumeroPrelevement, "asc")
        }
    }

    ngOnInit(): void {
        this.subject.pipe(
            debounceTime(500)
        ).subscribe((s) => {
            this.searchTaxon(s);
        });
    }

    getIBMRPhaseName(phase: number) {
        return StringConverter.getIBMRPhaseName(phase);
    }

    getIBMRTransectName(index) {
        return `Transect ${index}`
    }

    getSamplingCustomName(d: number) {
        this.model.CustomName = _.uniq(this.fullIBMRAlreadyPicked.filter(x => x.Preleve && x.NumeroPrelevement === d).map(y => y.CustomName))[0]
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    toggleNewSamplingNumberForm() {
        this.IsForNewSamplingNumber = !this.IsForNewSamplingNumber
        this.model.NumeroPrelevement = undefined;
    }

    onConfirm() {
        this.create();
    }

    onKeyUp() {
        if (!this.SearchText) {
            this.TaxonOptionList = [];
            return;
        }

        this.subject.next(this.SearchText);
    }

    displayFn(m: SANDRETaxionModel | string): string {
        if (m instanceof SANDRETaxionModel) {
            if (!m.Ordre && !m.Famille) {
                return `${m.Genre}`
            }
            if (m.Genre) {
                return `${m.Ordre && m.Ordre !== '' ? m.Ordre + ' /' : ''} ${m.Famille !== '' ? m.Famille + ' /' : ''} ${m.Genre}`;
            } else {
                return `${m.Ordre && m.Ordre !== '' ? m.Ordre + ' /' : ''} ${m.Famille}`;
            }
        }
        if (typeof (m) === 'string') {
            return m;
        }
    }

    setSelectedTaxon(event: MatAutocompleteSelectedEvent) {

        const selectedOption = this.TaxonOptionList.find(x => x.Code === event.option.value.Code);
        if (selectedOption) {
            this.model.SandreCode = selectedOption.Code;
            this.model.NomFamille = selectedOption.Famille;
            this.model.NomOrdre = selectedOption.Ordre;
            this.model.NomGenre = selectedOption.Genre;

            this.model.Instruction = selectedOption.Instruction;
            this.model.Code = selectedOption.CodeIBMR;

        }
    }

    async searchTaxon(s: string) {

        this.TaxonOptionList = [];
        if (this.CoreData.IsOffline) {
            this.TaxonOptionList = _.differenceWith(await db.getTaxonByFilter(s), this.transectAlreadyPicked.map(y => y.SandreCode), this.isEqual)

        }
    }

    isEqual(t0, t1) {
        return t0.Code === t1 ? true : false;
    }

    create() {
        if (!this.CanAdd) {
            return;
        }

        this.dialogRef.close(this.model);
    }
}
